import type { GetThirdPartyAuthConfigFunction } from '@shopee-user/business-customization-types';

// https://confluence.shopee.io/display/SAUT/%5BFor+User+FE+Reference%5D+FE+Integration+Guide
export const DEFAULT_SHOPEE_AUTH_SCOPES = ['userProfile'];

export const getShopeeOAuthConfig: GetThirdPartyAuthConfigFunction = () => {
  return {
    displayNameTransifyKey: 'label_auth_tob_app_display_name_spx',
    scopes: DEFAULT_SHOPEE_AUTH_SCOPES,
  };
};
